import axios from "axios";
import { pageRoutes } from "@pages/routes";
import * as toast from "@utils/toastHelper";
import { i18n } from "../../@commons/locales";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

instance.defaults.headers.common["Authorization"] = localStorage.getItem(
  "token"
)
  ? "Token " + localStorage.getItem("token")
  : "";

instance.defaults.headers.common["Accept-Language"] =
  i18n.resolvedLanguage ?? "fa";

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    let message: string[] | string | null = null;

    if (error.response?.status === 401) {
      message = error.response.data.detail ?? "auth error";

      localStorage.setItem("token", "");
      if (!window.location.pathname.includes("/auth")) {
        window.location.href = pageRoutes.LOGIN;
      }
    } else if (error.response?.status === 404) {
      message = "this request is not found";
    } else if (error.response?.status === 400) {
      const data: { [key: string]: string[] | string } | null =
        error.response?.data ?? null;
      if (data !== null) {
        Object.values(data).map((V) =>
          typeof V === "string" ? V : V.toString()
        );
        message = Object.values(data).map((V) =>
          typeof V === "string" ? V : V.toString()
        );
      }
    }

    toast.ErrorData(message ?? "some thing went wrong");

    return Promise.reject({ error, message });
  }
);

export default instance;
